// TODO The concept of SocialAccount should probably be renamed to ExternalAccount
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {StemDate} from "../../stem-core/time/Date";
import {UserProfile} from "./UserProfileStore";


export function normalizeEmail(email: string): string {
    return (email || "").trim().toLowerCase();
}


@makeEnum
export class SocialAccountProvider extends BaseEnum {
    static FACEBOOK;
    static GOOGLE;
    static TWITTER;
    static LINKEDIN;
    static GITHUB;
    static CDS = {value: "cds", name: "CDS"};
    static FULCO;
}


@globalStore
export class SocialAccount extends BaseStore("SocialAccount") {
    @field("UserProfile") user: UserProfile;
    @field(SocialAccountProvider) provider: SocialAccountProvider;
    @field(String) uid: string;
    @field(Object) extraData: object;
    @field(Date) createdAt: StemDate;
    @field(Date) lastModified: StemDate;

    getCDSProductId(): string {
        return this.uid.split("-")[0];
    }

    // For CDS accounts, returns the account number
    getCDSAccountNumber(): string {
        return this.uid.split("-")[1];
    }
}
